export default {
  SettingBaseDataLov: {
    valueSet: '值集',
    name: '名称',
    code: '编码',

    table: {
      name: '名称',
      code: '编码',
      sort: '排序',
      basicInformation: '基本信息',
      add: '新建',
      edit: '编辑',
      nameText: '请输入名称',
      codeText: '请输入编码',
    }
  }
};
